import { render, staticRenderFns } from "./technical-support.pug?vue&type=template&id=d57ffc3e&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./technical-support.scss?vue&type=style&index=0&id=d57ffc3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57ffc3e",
  null
  
)

export default component.exports